import { useState } from "react";
import Compress from "browser-image-compression";

interface UseMediaUploadReturn {
  dragActive: boolean;
  fileTooLarge: boolean;
  wrongFileType: boolean;
  encodeImageFileAsURL: (element: FileList, callback: (element: FileList, name: string, result: any, fileType: string) => void) => void;
  handleDrag: (e: React.FormEvent) => void;
  handleDrop: (event: React.DragEvent, callback: (element: FileList) => void) => void;
  setFileTooLarge: (value: boolean) => void;
  setWrongFileType: (value: boolean) => void;
  setDragActive: (value: boolean) => void;
}

export const useMediaUpload = (): UseMediaUploadReturn => {
  const [dragActive, setDragActive] = useState(false);
  const [fileTooLarge, setFileTooLarge] = useState(false);
  const [wrongFileType, setWrongFileType] = useState(false);

  const encodeImageFileAsURL = (
    element: FileList,
    callback: (element: FileList, name: string, result: any, fileType: string) => void
  ) => {
    const file = element[0];
    const reader = new FileReader();
    const imgExt = file.type.split("/");

    if (
      (imgExt[1] === "jpeg" || imgExt[1] === "png" || imgExt[1] === "jpg") &&
      imgExt[0] === "image"
    ) {
      const options = {
        maxSizeMB: file.size / 2,
        useWebWorker: true,
      };

      Compress(file, options)
        .then((compressedBlob) => {
          reader.readAsDataURL(compressedBlob);
          reader.onloadend = () => {
            callback(element, file.name, reader.result, file.type);
          };
        })
        .catch((_e) => {
          reader.readAsDataURL(file);
          reader.onloadend = () => {
            callback(element, file.name, reader.result, file.type);
          };
        });
    } else {
      reader.onloadend = () => {
        callback(element, file.name, reader.result, file.type);
      };
      if (file) {
        reader.readAsDataURL(file);
      }
    }
  };

  const handleDrag = (e: React.FormEvent) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragover" || e.type === "dragenter") {
      setDragActive(true);
    } else if (e.type === "dragleave") {
      setDragActive(false);
    }
  };

  const handleDrop = (
    event: React.DragEvent,
    callback: (element: FileList) => void
  ) => {
    event.preventDefault();
    event.stopPropagation();
    setDragActive(false);
    if (event.dataTransfer.files?.[0]) {
      callback(event.dataTransfer.files);
    } else {
      console.log("File was not uploaded.");
    }
  };

  return {
    dragActive,
    fileTooLarge,
    wrongFileType,
    encodeImageFileAsURL,
    handleDrag,
    handleDrop,
    setFileTooLarge,
    setWrongFileType,
    setDragActive,
  };
};
